/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpcomingClassRow
 */
export interface UpcomingClassRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpcomingClassRow
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof UpcomingClassRow
     */
    nextOccurrence: Date;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof UpcomingClassRow
     */
    day: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof UpcomingClassRow
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingClassRow
     */
    endTime: string;
}



/**
 * Check if a given object implements the UpcomingClassRow interface.
 */
export function instanceOfUpcomingClassRow(value: object): value is UpcomingClassRow {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('nextOccurrence' in value) || value['nextOccurrence'] === undefined) return false;
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function UpcomingClassRowFromJSON(json: any): UpcomingClassRow {
    return UpcomingClassRowFromJSONTyped(json, false);
}

export function UpcomingClassRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpcomingClassRow {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'nextOccurrence': (new Date(json['nextOccurrence'])),
        'day': DayOfWeekFromJSON(json['day']),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function UpcomingClassRowToJSON(json: any): UpcomingClassRow {
    return UpcomingClassRowToJSONTyped(json, false);
}

export function UpcomingClassRowToJSONTyped(value?: UpcomingClassRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'nextOccurrence': value['nextOccurrence'].toISOString(),
        'day': DayOfWeekToJSON(value['day']),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

